// extracted by mini-css-extract-plugin
module.exports = {"container":"ShortText_container__Uxw_g","icon":"ShortText_icon__1s__M","type_name":"ShortText_type_name__nFTK4"};